import { render } from "./step2.vue?vue&type=template&id=2cd4433f&scoped=true"
import script from "./step2.vue?vue&type=script&lang=js"
export * from "./step2.vue?vue&type=script&lang=js"

import "./step2.vue?vue&type=style&index=0&id=2cd4433f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd4433f"]])

export default __exports__